<div class="ipm-discount-filter" *ngIf="commonService.saleActive && options.length > 0">
    <span class="ipm-discount-filter__label">Diwali Discount</span>
    <button type="button" class="ipm-discount-filter__chip" *ngFor="let option of options"
        [class.active]="option.isSelected" (click)="onSelect(option.key)">
        {{ option.value | uppercase }}
    </button>
</div>
